import Swal from "sweetalert2";
import axios from "axios";
import { checkEmail } from "../utils/utils";

const RecoveryPassword = async () => {
    await Swal.fire({
        title: "Recuperar contraseña",
        input: 'email',
        inputPlaceholder: 'Ingrese su correo electrónico',
        inputValidator(value) {
            if (!value) {
                return 'Debe ingresar su correo electrónico'
            } else if (!checkEmail(value)){
                return 'Correo electrónico inválido'
            }
        },
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText:'Enviar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
    }).then(async (result) => {
        if (result.isConfirmed) {
            Swal.fire({
                title: 'Cargando...',
                text: 'Por favor espere',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            let uri = process.env.REACT_APP_API_URL + 'forgot-password';

            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json'
                }
            };
            
            let data = {
                email: result.value
            };

            try {
                await axios({
                    method: 'POST',
                    url: uri,
                    data: data,
                    headers: config.headers
                });

                Swal.fire(
                    {
                        title: 'Correo enviado',
                        text: 'Revise su bandeja de entrada',
                        icon: 'success',
                        confirmButtonText: 'Aceptar'
                    }
                );
            } catch (error) {
                Swal.fire(
                    {
                        title: 'Hemos encontrado inconvenientes',
                        text: 'Encontramos inconvenientes al enviar el correo, intenta nuevamente',
                        icon: 'warning',
                        confirmButtonText: 'Aceptar'
                    }
                );
            }
        }
    });
};

export default RecoveryPassword;